import 'uni-pages';
import Vue from 'vue'
import Page from './demo/packageMall/couponList.vue'
createPage(Page)